import React, { useEffect, useRef, useState } from 'react';

function CutCard({ cut, onToggleFavorite, pending, prominent }) {
  const { permalink, image, image_alt, name, lean, id, is_favorite } = cut;
  const favorite = !!is_favorite;
  const toggleFavorite = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onToggleFavorite(cut);
  };

  return (
    <a
      href={permalink}
      data-cut-id={id}
      className={`cut-card card grid__col-xs-12 grid__col-sm-6 grid__col-lg-3${prominent ? ' is-prominent' : ''}`}
    >
      <div className="cut-card__media-box">
        <button
          type="button"
          className="cut-card__heart"
          data-user-favorite={favorite ? 'true' : 'false'}
          aria-label={favorite ? 'Remove from favorites' : 'Save to favorites'}
          onClick={toggleFavorite}
          aria-pressed={favorite}
          disabled={pending}
        >
          <i className={favorite ? 'saved' : 'save'}></i>
        </button>
        {lean && <span className="cut-card__badge">Lean</span>}
        <img
          src={image ? image : ''}
          className="card__media"
          alt={image_alt ? image_alt : ''}
        />
      </div>
      <h4 className="card__title u--text-align-center">{name}</h4>
    </a>
  );
}

export default function CutsList({ cutsList, onToggleFavorite, pendingFavorites }) {
  const listRef = useRef(null);
  const [prominentId, setProminentId] = useState(null);

  useEffect(() => {
    const list = listRef.current;
    const touchQuery = window.matchMedia('(hover: none)');
    let frame = null;

    const updateProminent = () => {
      frame = null;
      let bestId = null;
      let bestArea = 0;
      let bestDistance = Infinity;
      if (touchQuery.matches) {
        list.querySelectorAll('.cut-card').forEach((card) => {
          const rect = card.querySelector('.cut-card__media-box').getBoundingClientRect();
          const height = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
          const width = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
          const area = height * width;
          const distance = Math.abs((rect.top + rect.bottom) / 2 - window.innerHeight / 2);
          // Prefer the largest visible image area, then the image nearest the center.
          if (area > 0 && (area > bestArea || (area === bestArea && distance < bestDistance))) {
            bestId = card.dataset.cutId;
            bestArea = area;
            bestDistance = distance;
          }
        });
      }
      setProminentId(bestId);
    };

    const scheduleUpdate = () => {
      if (frame === null) frame = window.requestAnimationFrame(updateProminent);
    };
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    list.addEventListener('load', scheduleUpdate, true);
    touchQuery.addListener(scheduleUpdate);
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(scheduleUpdate) : null;
    if (observer) observer.observe(list);
    scheduleUpdate();

    return () => {
      window.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
      list.removeEventListener('load', scheduleUpdate, true);
      touchQuery.removeListener(scheduleUpdate);
      if (observer) observer.disconnect();
      if (frame !== null) window.cancelAnimationFrame(frame);
    };
  }, [cutsList]);

  return (
    <div id="cuts__list" className="cuts__list" ref={listRef}>
      <section className="section">
        <div className="container">
          <div className="grid grid--card">
            {cutsList.map((cut) => (
              <CutCard key={cut.id} cut={cut} onToggleFavorite={onToggleFavorite} pending={pendingFavorites.includes(cut.id)} prominent={String(cut.id) === prominentId} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
